<div class="body" style="background-color: #292E3D;color: #fff;position: relative;">
  
  <div class="main-top-text">
    Call for speakers now is open!
  </div>
  <div class="main-top-img">
    <img src="../../../assets/images/shouye/header_en.png" class="banner-img-main">
    <button class="header-en-btn">Call for speakers</button>
    </div>
    <div class="top-num">
      <div class="top-num-div">
        <div class="top-num-div-left">
          <div class="left-title">Conference</div>
          <div class="left-title-large">Countdown</div>
        </div>
        <div class="top-num-div-right">
          <div class="right-list">
            <div class="right-list-num">12</div>
            <div class="right-list-desc">Weeks</div>
          </div>
          <div class="right-list">
            <div class="right-list-num">15</div>
            <div class="right-list-desc">Days</div>
          </div>
          <div class="right-list">
            <div class="right-list-num">10</div>
            <div class="right-list-desc">Hours</div>
          </div>
          <div class="right-list">
            <div class="right-list-num">12</div>
            <div class="right-list-desc">Minnutes</div>
          </div>
        </div>
      </div>
    </div>
    <section class="section-en">
      <div class="section-one">
        <div class="section-one-title">HOW2025 Eco Conference</div>
        <div class="section-one-title-text">is a global event focused on open-source innovation and database technology</div>
        <div class="section-one-title-content">
          with a strong emphasis on the PostgreSQL ecosystem. Held on June 27 in Jinan, it brings together developers, technical experts, and community leaders from around the world to learn from each other. The conference will highlight innovations in PostgreSQL, featuring IvorySQL (a PostgreSQL distribution with Oracle compatibility) while promoting collaboration between industry and academia to drive innovations in open-source database technologies.
        </div>
        <img src="../../../assets/images/shouye/line-one.png" alt="" width="100%"  style="z-index: 3;position: absolute;bottom: -60px;">
      </div>
      <div class="about-circle">
        <div class="circle-item cir1">
          <img src="../../../assets/images/shouye/icon_person.png" alt="" style="position: absolute;">
          <div class="num">2000+</div>
          <div class="circle-item-text">Participants </div>
        </div>
        <div class="circle-item cir2">
          <img src="../../../assets/images/shouye/icon_code.png" alt="" style="position: absolute;">
          <div class="num">50+</div>
          <div class="circle-item-text">Tech Experts </div>
        </div>
        <div class="circle-item cir1">
          <img src="../../../assets/images/shouye/icon_tool.png" alt="" style="position: absolute;">
          <div class="num">15<span style="font-size: 1.2rem;"></span></div>
          <div class="circle-item-text">Exciting Forums</div>
        </div>
        <div class="circle-item cir2">
          <img src="../../../assets/images/shouye/icon_zhibo.png" alt="" style="position: absolute;">
          <div class="num">2 Days<span style="font-size: 1.2rem;"></span></div>
          <div class="circle-item-text">Live Streaming</div>
        </div>
      </div>
      <div class="section-two" style="position: relative;">
        <img src="../../../assets/images/shouye/right-icon.png" alt="" style="position: absolute;right: 0;height: 800px;">
        <div class="section-two-title">Glance at the event</div>
        <div style="margin-top: 54px;display: flex;align-items: center;" class="w-limit">
          <div>
            <img src="../../../assets/images/shouye/Group 305.png" alt="">
          </div>
          <div style="margin-left: 100px;">
            <div class="section-two-right-title">
              Explore the latest in PostgreSQL, from core tech to real-world applications
            </div>
            <div class="section-two-right-text">
              alongside global developers and industry leaders. Discover how the Oracle-compatible IvorySQL is driving open-source innovation and ecosystem growth through collaboration across community, academia, and enterprise.
            </div>
          </div>
        </div>
      </div>
      <div style="position: relative; margin-top: 404px;">
     
        <img src="../../../assets/images/shouye/bar.png" alt="" style="position: absolute;right: 0;height: 356px;top: 130px;">
      </div>
      <div class="section-three w-limit" style="position: relative;">
        <img src="../../../assets/images/shouye/circle.png" alt="" style="position: absolute;top: -70px;left: -60px;opacity: 0.8;width: 120px;">
        <div class="section-three-title">Call For Speakers is Open!</div>
        <div class="section-three-title2">
          CFP is open until June 10,2025. Share your expertise on PostgreSQL, IvorySQL, or open-source database innovations. Here are some suggested topics for you.
        </div>
        <div  class="section-three-title2">
          - New capabilities in PostgreSQL <br/>
          - IvorySQL's Oracle compatible features <br/>
          - Open source Postgres user stories<br/>
          - Postgres community <br/>
          - Generally interesting Postgres knowledge & tips <br/>
          ...See all suggested topics...
        </div>
        <div>
          <button style="margin-top: 80px;">Submit Presentation</button>
        </div>
        
        <!-- <el-button class="section-three-btn">Submit Presentation</el-button> -->
      </div>
      <div class="section-four">
        <div>We’re here waiting for you...</div>
      </div>
    </section>
</div>

